/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const printCache = function (cache, logger) {
  cache
    .map(v => v.split('-'))
    .groupBy(v => v[1])
    .map((v, k) => {
      logger.log(`${k}`, 'success');
      const models = _(v)
        .groupBy(v => v[0])
        .map((v, k) => {
          logger.log(`\t${k}`, 'warn');
          const ids = v
            .map(v => {
              logger.log(`\t\t${v[2]}`, 'error');
              return v[2];
            })
            .join('\n\t\t');
          return `${k}\n\t\t${ids}`;
        })
        .join('\n\t');
      return `${k}\n\t${models}`;
    })
    .join('\n');
};

module.exports = printCache;
